module.exports = __webpack_public_path__ + "img/thumbnail_KirksDikDik_j_normal.82821f92.png";